export class UserInfo {
    id;
    is_guest;
    constructor(id, is_guest) {
        this.id = id;
        this.is_guest = is_guest;
    }
    as_headers() {
        return {
            'X-ZONT-User': this.id.toString(),
            'X-ZONT-Guest': this.is_guest.toString(),
        };
    }
    as_args() {
        return {
            _user: this.id.toString(),
            _guest: this.is_guest.toString(),
        };
    }
}
